<template>
  <el-dialog
    :visible.sync="visible"
    :show-close="true"
    custom-class="purchase-dialog"
    width="600px"
    @close="handleClose"
  >
    <div class="dialog-content">
      <div class="dialog-logo">
        <img :src="require('@/assets/images/logo-active.png')" :alt="getText('purchaseDialog.logoAlt', '亚科Logo')">
      </div>
      <div class="dialog-title">
        {{ getText('purchaseDialog.title', '更多品牌产品，尽在元素商城') }}
      </div>
      <el-button type="primary" class="goto-store" @click="handleGotoStore">
        {{ getText('purchaseDialog.gotoStore', '前往商城查看') }}
      </el-button>
      <div class="store-info">
        <img :src="require('@/assets/images/yssc-logo.png')" alt="元素商城" class="store-logo">
        <span>{{ getText('purchaseDialog.storeInfo', '由亚科集团旗下元素商城提供服务') }}</span>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: 'PurchaseDialog',
  
  data() {
    return {
      visible: false
    }
  },

  computed: {
    ...mapState({
      currentLanguage: state => state?.app?.language || 'zh' 
    })
  },

  watch: {
    // 监听语言变化
    currentLanguage: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          // 强制重新渲染组件以更新文本
          this.$forceUpdate()
        }
      },
      immediate: false
    }
  },

  methods: {
    // 安全的文本获取方法
    getText(key, fallback) {
      try {
        // 尝试使用 i18n
        if (this.$i18n && this.$i18n.t) {
          return this.$i18n.t(key)
        }
        // 如果 i18n 不可用，返回默认值
        return fallback
      } catch (error) {
        console.warn(`Translation failed for key: ${key}`, error)
        return fallback
      }
    },

    // 打开弹窗
    show() {
      this.visible = true
    },

    // 关闭弹窗
    handleClose() {
      this.visible = false
    },

    // 跳转到商城
    handleGotoStore() {
      window.open('https://www.b2star.com', '_blank')
      this.handleClose()
    }
  }
}
</script>

<style lang="less" scoped>
::v-deep .el-dialog__body{
  padding: 40px 30px;
  position: relative;
}
.purchase-dialog {
  :deep(.el-dialog__header) {
    display: none;
  }

  .dialog-content {
    text-align: center;

    .dialog-logo {
      position: absolute;
      top: -10px;
      left: 20px;
      
      img {
        width: 80px;
        height: auto;
      }
    }

    .dialog-title {
      font-size: 18px;
      color: #333;
      margin-bottom: 30px;
      padding-top: 40px;
      font-weight: normal;
    }

    .goto-store {
      width: 160px;
      height: 40px;
      background: #46618F;
      border-color: #46618F;
      font-size: 14px;
      margin-bottom: 50px;

      &:hover {
        background: lighten(#46618F, 10%);
        border-color: lighten(#46618F, 10%);
      }
    }

    .store-info {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 8px;

      .store-logo {
        width: 70px;
        height: 20px;
      }

      span {
        font-size: 12px;
        color: #999;
      }
    }
  }
}

// 全局样式覆盖
:deep(.el-dialog__headerbtn) {
  z-index: 10;
  right: 15px;
  top: 15px;
  
  .el-dialog__close {
    color: #999;
    font-size: 16px;
  }
}

:deep(.el-dialog) {
  border-radius: 4px;
}
</style> 